// extracted by mini-css-extract-plugin
module.exports = {"TagLine":"UnapprovedUserLogin_TagLine__1HW1E","Highlight":"UnapprovedUserLogin_Highlight__1epLr","Row":"UnapprovedUserLogin_Row__eiXfS"};